import MarkDownRenderer from '../../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
## **Interface Walkthrough**

The gRPC interface in HawkClient is divided into **three main areas**:

### 🔹 Left Panel – Collections
- Organize gRPC requests inside collections
- Each gRPC request is saved as a file
- Easily version-controlled using Git

### 🔹 Center Panel – Request Composer
- Target gRPC endpoint (e.g. \`grpcs://grpcb.in:9000\`)
- Select service & method from loaded proto
- Compose request messages
- Control streaming manually

### 🔹 Right Panel – Responses
- View multiple responses for streaming calls
- Inspect metadata and trailers
- Responses are grouped chronologically

![gRPC Interface Walkthrough](/send-requests/grpc/overview.png)
`;

const GRPCInterfaceWalkthrough = () => {
    return (
        <MarkDownRenderer
            title="Interface Walkthrough"
            markDownText={markdownContent}
        />
    );
};

export default GRPCInterfaceWalkthrough;
